/* eslint-disable jsx-a11y/alt-text */
import { debounce } from '@outdoor-voices/ui';
import { gsap } from 'gsap/dist/gsap';
import { memo, useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { RESIZE } from '@outdoor-voices/ui/dist/config/constants';
import PropTypes from 'prop-types';
import { getRootOffset } from './utils';
import css from './Dress.module.scss';
import VideoTitle from './VideoTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var positionElement = function positionElement(el, image) {
  el.style.height = "".concat(image.offsetWidth + window.innerWidth * 0.2, "px");
  el.style.top = "".concat(getRootOffset(image) - window.innerWidth * 0.4, "px"); // console.info(getRootOffset(image), window.innerHeight * 0.5);
};

var Dress = function Dress(_ref) {
  var children = _ref.children,
      copy = _ref.copy,
      name = _ref.name,
      url = _ref.url,
      isMobile = _ref.isMobile,
      video = _ref.video;
  var rootRef = useRef(null);
  var scroller = useRef();
  useEffect(function () {
    if (isMobile) {
      return;
    }

    var current = rootRef.current;
    var images = gsap.utils.toArray('[data-dress-image="true"]', current);
    var els = []; // Build elements on the y axis that correspond to the images/quotes on the x-axis of our dress

    images.forEach(function (image, idx) {
      var el = document.createElement('div');
      el.style.position = 'absolute';
      el.style.left = 0;
      el.style.width = "2px";
      positionElement(el, image); // el.style.zIndex = 10000;
      // el.style.background = idx % 2 === 1 ? 'red' : 'black';

      document.body.appendChild(el);
      els.push(el);
      scroller.current = ScrollTrigger.create({
        id: "".concat(name, "-").concat(idx),
        // markers: true,
        onEnter: function onEnter() {
          gsap.to(image, {
            opacity: 1,
            x: 0
          });
        },
        onEnterBack: function onEnterBack() {
          gsap.to(image, {
            opacity: 1,
            x: 0
          });
        },
        onLeave: function onLeave() {
          gsap.to(image, {
            opacity: 0,
            x: -30
          });
        },
        onLeaveBack: function onLeaveBack() {
          gsap.to(image, {
            opacity: 0,
            x: 30
          });
        },
        start: function start() {
          return 'top 100%';
        },
        trigger: el
      });
    });

    var onResize = function onResize() {
      els.forEach(function (el, idx) {
        positionElement(el, images[idx]);
      });
    };

    var debouncedResize = debounce(onResize, 150);
    window.addEventListener(RESIZE, debouncedResize);
    return function () {
      els.forEach(function (el) {
        return document.body.removeChild(el);
      });
      window.removeEventListener(RESIZE, debouncedResize);
    };
  }, [isMobile, name]);
  return /*#__PURE__*/_jsxs("div", {
    "data-dress": "true",
    className: css.dress,
    ref: rootRef,
    children: [/*#__PURE__*/_jsx(VideoTitle, {
      copy: copy,
      isMobile: isMobile,
      name: name,
      url: url,
      video: video
    }), /*#__PURE__*/_jsx("div", {
      className: css.images,
      children: children
    })]
  });
};

Dress.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  copy: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  video: PropTypes.shape({}).isRequired
};
export default /*#__PURE__*/memo(Dress);